import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetGroupsAction } from '../../actions/groups/get-groups-action';
import { GetGroupsSuccessAction } from '../../actions/groups/get-groups-success-action';
import { GetGroupsErrorAction } from '../../actions/groups/get-groups-error-action';

@Injectable()
export class GetGroupsEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetGroupsActions = createEffect(() => this.actions
    .pipe(
      ofType(GetGroupsAction.type),
      mergeMap(action => {
        const getGroupsAction = <GetGroupsAction>action;
        return this.api.getGroups(getGroupsAction.bijbEvent).then(groups => {
          return new GetGroupsSuccessAction(groups);
        }, error => {
          return new GetGroupsErrorAction({ ...error, fatal: true });
        });
      })
    ));
}
